import { loginApis } from "@/api";
import { PHANTOMONLINE_GLOBAL_CONFIG } from "@/api/constants";
import { getEnterpriseIdFromStorage, storageGetItem } from "@/utils/utils";
import { parse, stringify } from "qs";
import store from "@/store";
import { userService } from "@/store/services";
import { genSignInOrSignUpBasicParams } from "./base";
import { GA_SIGN_UP_SCENE, sendGA } from "./ga";
import { sharePointGASender } from "@/store/services/GoogleAnalyticsSender";

export async function consumeTicketAfterLoggedInFromSignUp({ ticket, enterpriseId, remember_me, role, callback }) {
    const casService = getSignInOrUpServiceByIframe();
    return consumeTicketAfterLoggedIn({ ticket, enterpriseId, remember_me, role, casService, callback });
}
export async function consumeTicketAfterLoggedInFromTokenExpired({ ticket, enterpriseId, remember_me, role, callback }) {
    const { casService } = store.userStore
    return consumeTicketAfterLoggedIn({ ticket, enterpriseId, remember_me, role, casService, callback });
}
export async function consumeTicketAfterLoggedInFromSignIn({ ticket, enterpriseId, remember_me, role, callback }) {
    const casService = genSignInOrUpService();
    return consumeTicketAfterLoggedIn({ ticket, enterpriseId, remember_me, role, casService, callback });
}

async function consumeTicketAfterLoggedIn({ ticket, enterpriseId, remember_me, role, casService, callback }) {
    try {
        let result = await userService.getUserInfoByTicket(ticket, enterpriseId, remember_me, role, undefined, casService);

        if (result.token) {
            //ONLINERD-6688 登录成功->
            store.userStore.checkUserEnv(result.token);
            enterpriseId && store.userStore.updateRoleInfo(role, enterpriseId)
            store.userStore.updateIsTokenExpired(false);
            sharePointGASender.signInSuccessful()
            store.foxitSignStore.initFoxitSignCountInfo();
            store.appStore.initEnterpriseSettingInfo();
            callback && callback()
        }

        store.appStore.showWaitingForSignIn(false);
        userService.resetHideNotifyErrors()
        await store.collaborationStore.startNotificationPolling();

        if (!result.token) {
            return Promise.reject()
        }
    } catch (error) {
        userService.resetHideNotifyErrors()
        sharePointGASender.signInInterrupted()
        console.error(error);

        return Promise.reject()
    }
}

async function setGlobalConfig() {
    loginApis.cleanStorage();
    return new Promise((resolve, reject) => {
        const config = storageGetItem(localStorage, PHANTOMONLINE_GLOBAL_CONFIG);
        if (config) {
            window[PHANTOMONLINE_GLOBAL_CONFIG] = JSON.parse(config);
            resolve(null);
            return;
        }

        function handler(event: StorageEvent) {
            if (event.key === PHANTOMONLINE_GLOBAL_CONFIG) {
                window[PHANTOMONLINE_GLOBAL_CONFIG] = JSON.parse(event.newValue);
                window.removeEventListener('storage', handler);
                resolve(null);
            }
        }
        window.addEventListener('storage', handler);
    })
}

export async function popupLoginWindow() {
    store.appStore.showWaitingForSignIn(true);
    store.userStore.doSendGAEventByUser({ eventKey: 'sign_in', label: 'upper_right_area' } as any);
    sharePointGASender.signInPopUp()
    await setGlobalConfig();
    const signInUrl = genSignInUrl();
    loginApis.loginInNewWindow(signInUrl, (...args: any) => {
        sendGA(GA_SIGN_UP_SCENE.SIGN_UP_POPUP_TO_LOGIN_SUCCESS);
        consumeTicketAfterLoggedInFromSignIn.apply(null, args);
    }, () => {
        sendGA(GA_SIGN_UP_SCENE.SIGN_UP_POPUP_TO_LOGIN_INTERRUPTED);
        store.appStore.showWaitingForSignIn(false);
    }, 'login');
}

function genSignInUrl() {
    const {
        email,
        server_config,
        cTag,
        useCWS,
    } = parse(window.location.href);
    const { lng: { full }, isWindowsOS } = store.appStore;
    const hf = isWindowsOS ? 0 : 1;

    const urlParams = {
        ...genSignInOrSignUpBasicParams(cTag as string),
        al: full,
        service: genSignInOrUpService(),
        hf,
    };
    if (email) urlParams['email'] = email;
    if (server_config) urlParams['server_config'] = server_config;

    const request = stringify(urlParams);
    const domain = useCWS ? window[PHANTOMONLINE_GLOBAL_CONFIG].cwsApiUrl : store.appStore.accountUrl;
    return `${domain}/site/plugin-sign-in?${request}`;
}

function genSignInOrUpService() {
    const { protocol, host } = window.location;
    const casService = `${protocol}//${host}/sites/sign-success.html`;
    return casService;
}
function getSignInOrUpServiceByIframe() {
    return `${genSignInOrUpService()}?noticeType=1`;
}

export function genSignUpUrl() {
    const { cTag } = parse(window.location.href);
    const {
        lng: { full },
    } = store.appStore;
    const domain = store.appStore.accountUrl;
    const request = stringify({
        ...genSignInOrSignUpBasicParams(cTag as string),
        al: full,
        service: getSignInOrUpServiceByIframe(), // sign up by iframe
        noticeType: 1,
    });
    return `${domain}/site/sign-up?${request}`;
}

export function genLoginUrl() {
    const params = { noticeType: 1}
    const enterpriseId = getEnterpriseIdFromStorage();

    if (enterpriseId) {
        Object.assign(params, { enterpriseId })
    }

    return loginApis.getLoginUrl(false, params)
}
